export default "__VITE_ASSET__xbj6igUM__"